import Gallery from "./main/gallery";

'use strict';

( function ( $, w ) {

    var $window = $( w );

    $window.on( 'elementor/frontend/init', function() {

        const is_single = document.querySelector('body.single-post');

        /**
         * Gallery widget added in Elementor Template for Single Post
         * With no images and hidden (we just need the lightbox for our WordPRess images)
         * Copy the data-id of slider here ('ec66ebd')
         */
        const el_lightbox = 'ec66ebd';

        // on single post site add gallery images to Elementor lightbox
        if( is_single ) {
            new Gallery(el_lightbox);
        }
    } );


} ( jQuery, window ) );